<template>
    <div class="wrap">
        <div class="cancle bh bbetween">
            <div class="left fz_34" @click="onSumbmit(0)">取消</div>
            <div class="showTime fz_30">{{showCutTime || "0天0小时"}}</div>
            <div class="right fz_34" @click="onSumbmit(1)">确定</div>
        </div>
        <div class="info bh">
            <button
                type="button"
                class="getInfo b1"
                :class="{'active':flag}"
                @click="changeFlag('get')"
            >
                <div class="title">取车时间</div>
                <div class="timeInfo">{{showGetTime || "请选择"}}</div>
            </button>
            <button class="rtnInfo b1" :class="{'active':!flag}" @click="changeFlag('rtn')">
                <div class="title">还车时间</div>
                <div class="timeInfo">{{showRtnTime || "请选择"}}</div>
            </button>
        </div>
        <van-picker
            v-show="flag"
            ref="picker"
            swipe-duration="100"
            @change="getChange"
            :columns="getColumns"
        />
        <van-picker
            v-show="!flag"
            ref="picker"
            swipe-duration="100"
            @change="rtnChange"
            :columns="rtnColumns"
        />
    </div>
</template>
<script>
import moment from "moment";
import util from "@/utils/index";
export default {
    props: ["value", "getOrRtn"],
    data() {
        return {
            getColumns: [
                // 日期
                {
                    values: [],
                    defaultIndex: 0
                },
                // 时间
                {
                    values: [],
                    defaultIndex: 0
                }
            ],
            rtnColumns: [
                // 日期
                {
                    values: [],
                    defaultIndex: 0
                },
                // 时间
                {
                    values: [],
                    defaultIndex: 0
                }
            ],
            // 总的日期段 对象形式
            dateObj: {},
            // 总的日期段 数组形式
            dateArr: [],
            // 总的时间段 9点~18点
            timeArr: [],
            // 取车组件的日期段
            getDateArr: [],
            // 取车组件当天时间段
            curGetTimeArr: [],
            // 取车日期下标
            // getCarIndex: [],
            // 取车日期
            getCarTime: [],
            // 还车组件的日期段
            rtnDateArr: [],
            // 还车组件最大时间段
            bigRtnTimeArr: [],
            // 还车组件最小时间段
            smallRtnTimeArr: [],
            // 还车日期
            rtnCarTime: "",
            // 展示取车时间
            showGetTime: "",
            // 展示还车时间
            showRtnTime: "",
            // 租车时长
            showCutTime: "",
            // 颜色和组件切换标识
            flag: true,
            // 变量
            temp: ""
        };
    },
    methods: {
        // 得到从startTime开始的，days天内的时间段（数组ydArr和对象ydObj形式）
        initDataFunc(startTime, days) {
            let temp1, temp2;
            const ydObj = {},
                ydArr = [];
            for (let i = 0; i <= days; i++) {
                temp1 = moment(startTime)
                    .add(i, "days")
                    .format("YYYY-MM-DD");
                temp2 =
                    temp1
                        .split("-")
                        .slice(1, 3)
                        .join("月") + "日";
                ydObj[temp2] = temp1;
                ydArr.push(temp2);
            }
            return [ydObj, ydArr];
        },
        // 得到从starHour开始，endHour结束，间隔为cutMinu(能整除60的分钟数)的时间段数组
        initTimeFunc(startHour, endHour, cutMinu) {
            const num = ((endHour - startHour) * 60) / cutMinu;
            const temp = [];
            for (let i = 0; i <= num; i++) {
                temp.push(
                    moment(`2000-01-01 0${startHour}:00`)
                        .add(cutMinu * i, "minutes")
                        .format("HH:mm")
                );
            }
            return temp;
        },
        // 点击取车 还车 时执行函数
        changeFlag(v) {
            const me = this;
            // 取车时
            if (v == "get") {
                me.flag = true;
                console.log(111);
                console.log(this.value);
            }
            // 还车时
            if (v == "rtn") {
                me.flag = false;
                if (!me.rtnCarTime || me.rtnCarTime == this.temp) {
                    this.showCutTime = "3天0小时";
                    // 根据取车时间 计算还车时间
                    const timeRealIndex = me.timeArr.indexOf(me.getCarTime[1]),
                        dateRealIndex = me.dateArr.indexOf(me.getCarTime[0]);
                    // console.log(timeRealIndex, me.getCarIndex, dateRealIndex);
                    if (timeRealIndex == 18) {
                        me.rtnDateArr = me.dateArr.slice(
                            dateRealIndex + 1,
                            dateRealIndex + 5
                        );
                        me.smallRtnTimeArr = me.timeArr.slice(0);
                    } else {
                        me.rtnDateArr = me.dateArr.slice(
                            dateRealIndex,
                            dateRealIndex + 4
                        );
                        me.smallRtnTimeArr = me.timeArr.slice(
                            timeRealIndex + 1
                        );
                    }
                    me.bigRtnTimeArr = me.timeArr.slice(0, timeRealIndex + 1);
                    // 展示还车时间
                    me.$refs.picker.setColumnValues(0, me.rtnDateArr);
                    me.$refs.picker.setColumnValues(1, me.bigRtnTimeArr);
                    // 保证切换时 选中最大还车日期
                    me.$refs.picker.setIndexes([
                        dateRealIndex + 3,
                        timeRealIndex
                    ]);
                    // 记录当前选中时间
                    me.rtnCarTime = me.$refs.picker.getValues();
                    me.showRtnTime = `${me.dateObj[me.rtnCarTime[0]]} ${
                        me.rtnCarTime[1]
                    }`;
                }
            }
        },
        //  取车组件滑动
        getChange(Picker, data, index) {
            const me = this;
            this.showCutTime = this.showRtnTime = this.rtnCarTime = "";
            // 判断 如果是当天，就展示处理过的取车时间段  否则就展示9点-18点间所有的时间段
            if (Picker.getColumnIndex(0) == 0) {
                Picker.setColumnValues(1, me.curGetTimeArr);
            } else {
                Picker.setColumnValues(1, me.timeArr);
            }
            me.getCarTime = Picker.getValues();
            // me.getCarIndex = Picker.getIndexes();
            me.showGetTime = `${me.dateObj[me.getCarTime[0]]} ${
                me.getCarTime[1]
            }`;
        },
        // 还车组件滑动
        rtnChange(Picker, data, index) {
            const me = this;
            // 判断 如果是最大还车日，就展示处理过的取车时间段  否则就展示9点-18点间所有的时间段
            if (Picker.getColumnIndex(0) == 3) {
                Picker.setColumnValues(1, me.bigRtnTimeArr);
            } else if (Picker.getColumnIndex(0) == 0) {
                Picker.setColumnValues(1, me.smallRtnTimeArr);
            } else {
                Picker.setColumnValues(1, me.timeArr);
            }
            me.rtnCarTime = Picker.getValues();
            me.showRtnTime = `${me.dateObj[me.rtnCarTime[0]]} ${
                me.rtnCarTime[1]
            }`;
            const temp = util.diffTime(
                `${me.dateObj[me.getCarTime[0]]} ${me.getCarTime[1]}`,
                `${me.dateObj[me.rtnCarTime[0]]} ${me.rtnCarTime[1]}`
            );
            if (temp["mins"] > 0) {
                this.showCutTime = `${temp["day"]}天${temp["hours"]}小时`;
            } else {
                this.showCutTime = `${temp["day"]}天${temp["hours"]}小时`;
            }
        },
        // 点击确定按钮
        onSumbmit(v) {
            const me = this;
            // 区分点击取消还是确定，便于父组件是否更新数据
            const getCarTime = `${me.dateObj[me.getCarTime[0]]} ${
                me.getCarTime[1]
            }`;
            const rtnCarTime = this.rtnCarTime
                ? `${me.dateObj[me.rtnCarTime[0]]} ${me.rtnCarTime[1]}`
                : "";
            const timeInfo = {
                getCarTime: getCarTime,
                rtnCarTime: rtnCarTime,
                showCutTime: me.showCutTime,
                isChange: v
            };
            me.$emit("input", timeInfo);
        }
    },
    watch: {
        getOrRtn() {
            this.changeFlag(this.getOrRtn);
        }
    },
    mounted() {
        // 初始化数据
        console.log(this.getOrRtn);
        let curDatArr, nowTime;
        const date = new Date(),
            temp = this.initDataFunc(date, 18),
            datArr = temp[1],
            timArr = this.initTimeFunc(9, 18, 30),
            nowMinu = moment().minutes(),
            nowHours = moment().hours();
        this.dateObj = temp[0];
        if (nowHours < 9) {
            nowTime = "09:00";
            curDatArr = datArr.slice(0, 16);
        } else if (nowHours >= 18) {
            nowTime = "09:00";
            curDatArr = datArr.slice(1, 16);
        } else {
            if (nowMinu < 30) {
                nowTime = moment(`2000-01-01 ${nowHours}:30`).format("HH:mm");
            } else {
                nowTime = moment(`2000-01-01 ${nowHours + 1}:00`).format(
                    "HH:mm"
                );
            }
            curDatArr = datArr.slice(0, 16);
        }
        this.getDateArr = curDatArr;
        this.dateArr = datArr;
        this.curGetTimeArr = timArr.slice(timArr.indexOf(nowTime));
        this.timeArr = timArr;
        this.$refs.picker.setColumnValues(0, curDatArr);
        this.$refs.picker.setColumnValues(1, this.curGetTimeArr);
        this.getColumns[0].values = curDatArr;
        this.getColumns[1].values = this.curGetTimeArr;
        this.getCarTime = this.$refs.picker.getValues();
        // this.getCarIndex = this.$refs.picker.getIndexes();
        this.showGetTime = `${this.dateObj[this.getCarTime[0]]} ${
            this.getCarTime[1]
        }`;
        this.showRtnTime = moment(this.showGetTime)
            .add(3, "day")
            .format("YYYY-MM-DD HH:mm");
        this.showCutTime = "3天0小时";
        if (this.getOrRtn == "get") {
            this.rtnCarTime = moment(this.showRtnTime)
                .format("MM月DD日 HH:mm")
                .split(" ");
            this.temp = this.rtnCarTime;
        }
        this.changeFlag(this.getOrRtn);
    }
};
</script>
<style scoped lang="scss">
.wrap {
    background-color: #fff;
    .cancle {
        padding: 30px 30px;
    }
    .info {
        button {
            height: 120px;
            background-color: #ddd;
            border: none;
            &.active {
                background-color: #c30d23;
                color: #fff;
            }
        }
    }
}
</style>